import { GIPHY_TYPE } from 'wix-rich-content-common';
var giphyStrategy = function () {
    var _a;
    return ({
        config: (_a = {},
            _a[GIPHY_TYPE] = {
                giphySdkApiKey: '8LVphUXpyDK77BY7BhYMXgFU6TwhSKkA',
            },
            _a),
    });
};
export default giphyStrategy;
//# sourceMappingURL=giphyStrategy.js.map